import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import "./index.css";

import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import Chatbot from "./components/Chatbot";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import SuccessStories from "./pages/SuccessStories";
import Events from "./pages/Events";
import Donate from "./pages/Donate";
import Contact from "./pages/Contact";
import { BecomeAMentee, BecomeAMentor, Volunteer } from "./pages/Applications";
import { News, Gallery, Resources, Partners } from "./pages/Misc";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import AuthCallback from "./pages/AuthCallback";
import KingsCircle from "./pages/KingsCircle";
import RequestHelp from "./pages/RequestHelp";
import PartnerReferrals from "./pages/PartnerReferrals";
import Portal from "./pages/Portal";
import Admin from "./pages/Admin";
import Turnaround from "./pages/Turnaround";
import StrongMinds from "./pages/StrongMinds";
import StrongMindsCenter from "./pages/StrongMindsCenter";
import ParentsPage from "./pages/Parents";
import LittleLeaders from "./pages/LittleLeaders";
import Impact from "./pages/Impact";
import Founder from "./pages/Founder";
import Partnerships from "./pages/Partnerships";
import Enroll from "./pages/Enroll";
import ResourceLibrary from "./pages/ResourceLibrary";
import Blog from "./pages/Blog";
import NewHome from "./pages/NewHome";

function usePageViews(location) {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: location.pathname + location.search, page_location: window.location.href });
    }
  }, [location.pathname, location.search]);
}

function AppRouter() {
  const location = useLocation();
  usePageViews(location);
  // Process OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/:slug" element={<Programs />} />
        <Route path="/strong-minds" element={<StrongMinds />} />
        <Route path="/strong-minds-center" element={<StrongMindsCenter />} />
        <Route path="/parents" element={<ParentsPage />} />
        <Route path="/little-leaders" element={<LittleLeaders />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/enroll" element={<Enroll />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/events" element={<Events />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/new-home" element={<NewHome />} />
        <Route path="/kings-circle" element={<KingsCircle />} />
        <Route path="/turnaround" element={<Turnaround />} />
        <Route path="/turnaround-toolkit" element={<Turnaround />} />
        <Route path="/request-help" element={<RequestHelp />} />
        <Route path="/partner/referrals" element={<PartnerReferrals />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/become-a-mentee" element={<Enroll />} />
        <Route path="/become-a-mentor" element={<BecomeAMentor />} />
        <Route path="/volunteer" element={<Volunteer />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blog />} />
        <Route path="/news" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/resources" element={<ResourceLibrary />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/get-involved" element={<Partners />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Chatbot />
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
